import PropTypes from 'prop-types';
import {
  INBOX_MSG_TYPES,
  PROFILE_BLOCKS,
} from '../../../services/utilityFunctions';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import FileProp from '../../../commonComponents/propTypes/fileProp';

const propType = {
  title: PropTypes.string,
  createdAt: PropTypes.number,
  type: PropTypes.oneOf(INBOX_MSG_TYPES).isRequired,
  info: PropTypes.string,
  url: PropTypes.string,
  feed: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    url: PropTypes.string,
  }),
  image: PropTypes.shape(ImageProp.propType),
  survey: PropTypes.shape({ title: PropTypes.string }),
  profileBlock: PropTypes.oneOf(PROFILE_BLOCKS),
  file: PropTypes.shape(FileProp.propType),
  isBadgeRead: PropTypes.bool,
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default { propType };
